import globalSite from '../api/globalSite'
import { setCookie } from '../utils/cookie'
import { MessageBox } from 'element-ui';

const actions = {
  // 获取认证token
  getToken ({ commit, dispatch }, payload) {
    const { token, router } = payload;
    return globalSite.getToken({ token })
      .then(response => {
        if (response.status === 200) {
          const { data } = response;
          // 诸葛 IO 标识用户信息
          zhuge.identify(data.account.user_id, {
            '用户名': data.account.username
          })
          setCookie('cookieToken', `JWT ${data.token}`, 1);
          setCookie('accountInfo', JSON.stringify(data.account)); // 存储用户信息
          localStorage.setItem('accountInfo', JSON.stringify(data.account)); // 存储用户信息
          router.push('/dashboard');
          if (data.first) {
            MessageBox({
              title: '一键登录服务开通成功',
              message: '系统将免费赠送20次，供您测试使用！',
              customClass: 'messagebox-customed',
              showConfirmButton: false
            });
          }
        } else {
          setTimeout(() => {
            if (process.env.NODE_ENV === 'development') {
              window.location.href = 'http://franky.upyun.com/login/';
            } else {
              window.location.href = 'https://console.upyun.com/accounts/signout/';
            }
          }, 1000);
        }
      });
  },
  logOut () {
    return globalSite.logOut()
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js